// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@turnerBlueprint/App/SharedStyles/CartLineSharedStyles";
import {
    createListDetailButtonStyle,
    linkLikeButtonCss,
} from "@turnerBlueprint/App/SharedStyles/MyAccountDetailsStyles";
import { orderLinesListStyles } from "@turnerBlueprint/Overrides/Components/OrderLinesList";
import IconReorder from "@turnerBlueprint/XDL/Icons/IconReorder";
import { color, mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.gridContainer = {
    gap: 10,
    css: css`
        margin-top: 24px;
        padding-top: 24px;
        border-top: 1px solid ${color("common.border")};
    `,
};

orderLinesListStyles.linesHeaderStyles = {
    wrapper: {
        css: css`
            grid-template-columns:
                91px minmax(0, 14px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 116px) minmax(0, 170px)
                minmax(16px, 65px);
            ${xScreen("lte", "md")} {
                grid-template-columns:
                    99px minmax(0, 14px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 116px) minmax(0, 170px)
                    minmax(0, 16px);
            }
        `,
    },
};

orderLinesListStyles.cartLineContainer = {
    container: {
        css: css`
            grid-template-columns:
                91px minmax(0, 14px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 116px) minmax(0, 170px)
                minmax(16px, 65px);
            ${xScreen("lte", "md")} {
                grid-template-columns:
                    99px minmax(0, 14px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 116px) minmax(0, 170px)
                    minmax(0, 16px);
            }
        `,
    },
    description: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-row: 1 / 3;
                grid-column: ${({ includeLeftActions }: any) => (includeLeftActions ? "3 / 8" : "2 / 8")};
            }
        `,
    },
    remove: {
        css: css`
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    },
};

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        wrapper: {},
    },
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        wrapper: {},
    },
};

orderLinesListStyles.unitOfMeasure = {
    ...cartLineSharedStyles.unitOfMeasure,
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            display: block;
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
    qtyLabelNotEditable: {
        css: css`
            display: block;
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.reorderCartLineIcon = {
    ...mergeWithCss(createListDetailButtonStyle(IconReorder), linkLikeButtonCss),
};
